import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import GlobalStyle from "./styles/global";
import Routes from "./routes";
import "react-phone-input-2/lib/style.css";
import "react-toastify/dist/ReactToastify.css";
import "cropperjs/dist/cropper.css";
// import {Helmet} from "react-helmet";
import TagManager from "react-gtm-module";

const App: React.FC = () => {
  
  useEffect(() => {

    if (process.env.REACT_APP_ENV === 'production') {
      const tagManagerArgs = {
        gtmId: "GTM-KDD46QX",
      };
      TagManager.initialize(tagManagerArgs);
    }

  }, []);
  

  return (
    <Router>
      <Routes />
      <GlobalStyle />
      <ToastContainer />
    </Router>
  );
};

export default App;
